import React from 'react';
import PropTypes from 'prop-types';

import {Box, Button, ButtonBase, Stack, Typography} from 'views/components';
import {Translate} from 'views/module';

const SkillsList = (props) => {
  const {groupedSkills, openNew, onSelectSkill, selectedSkillRn} = props;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        border: '1px solid',
        borderColor: '#E8E4DE',
        overflow: 'hidden',
      }}
    >
      <Stack
        direction='row'
        alignItems='flex-start'
        justifyContent='space-between'
        sx={{
          px: '32px',
          paddingTop: '24px',
          paddingBottom: '12px',
          gap: '112px',
        }}
      >
        <Stack sx={{gap: '8px'}}>
          <Typography
            sx={{
              fontWeight: 400,
              fontStyle: 'Regular',
              fontSize: '17px',
              color: '#1A1916',
              lineHeight: '100%',
            }}
          >
            <Translate expression='skills.skills.List.Title' />
          </Typography>
          <Typography
            sx={{
              fontWeight: 400,
              fontStyle: 'Regular',
              fontSize: '12px',
              color: '#A8A49E',
              lineHeight: '100%',
              whiteSpace: 'nowrap',
            }}
          >
            <Translate expression='skills.skills.List.Subtitle' />
          </Typography>
        </Stack>
        <Button
          onClick={openNew}
          disableElevation
          sx={{
            'borderRadius': '7px',
            'p': '4px',
            'gap': '10px',
            'fontWeight': 500,
            'fontStyle': 'Medium',
            'fontSize': '12px',
            'color': '#FFFFFF',
            'backgroundColor': '#DA7955',
            '&:hover': {
              backgroundColor: '#DA7955',
              boxShadow: 'none',
            },
            'textTransform': 'none',
          }}
        >
          <Translate expression='skills.skills.List.NewSkill' />
        </Button>
      </Stack>
      <Box sx={{borderBottom: '1px solid #E8E4DE'}}></Box>
      <Stack
        sx={{
          flex: 1,
          px: '16px',
          py: '16px',
          gap: '12px',
          overflowY: 'auto',
        }}
      >
        {
          groupedSkills.length === 0 &&
          <Typography
            sx={{
              fontSize: '12px',
              fontWeight: 400,
              color: '#A8A49E',
              lineHeight: '150%',
            }}
          >
            <Translate expression='skills.skills.List.Empty' />
          </Typography>
        }
        {
          groupedSkills.map((group) => (
            <Stack
              key={group.groupName}
              sx={{
                gap: '8px',
              }}
            >
              <Typography
                sx={{
                  fontSize: '10px',
                  fontWeight: 500,
                  color: '#A8A49E',
                  lineHeight: '100%',
                  textTransform: 'uppercase',
                }}
              >
                {group.groupName}
              </Typography>
              <Stack
              >
                {
                  group.skills.map((skill) => {
                    const isSelected = skill.skillRn === selectedSkillRn;

                    return (
                      <ButtonBase
                        key={skill.skillRn}
                        onClick={() => onSelectSkill(skill)}
                        aria-pressed={isSelected}
                        sx={{
                          'justifyContent': 'flex-start',
                          'px': '8px',
                          'py': '10px',
                          'borderRadius': '8px',
                          'backgroundColor': isSelected ? '#F3F1EE' : 'transparent',
                          '&:hover': {
                            backgroundColor: isSelected ? '#F3F1EE' : '#F8F6F3',
                          },
                          ...(isSelected && {
                            '&::before': {
                              content: '""',
                              position: 'absolute',
                              left: '0',
                              top: '50%',
                              transform: 'translateY(-50%)',
                              width: '4px',
                              height: '18px',
                              borderRadius: '4px',
                              backgroundColor: '#DA7955',
                            },
                          }),
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: '12px',
                            fontWeight: 400,
                            fontStyle: 'Regular',
                            color: isSelected ? '#1A1916' : '#6B6760',
                            lineHeight: '100%',
                          }}
                        >
                        /{skill.name}
                        </Typography>
                      </ButtonBase>
                    );
                  })
                }
              </Stack>
            </Stack>
          ))
        }
      </Stack>
    </Box>
  );
};

SkillsList.propTypes = {
  groupedSkills: PropTypes.array.isRequired,
  onSelectSkill: PropTypes.func.isRequired,
  openNew: PropTypes.func.isRequired,
  selectedSkillRn: PropTypes.string,
};

export default React.memo(SkillsList);
